import { Injectable } from '@angular/core';
import { EnvConfigService } from './env-config.service';
import { Link } from '@types';
import { Page } from '@bloomreach/spa-sdk';
import { replaceTokens } from '@utils/text/string-utils';

@Injectable({
  providedIn: 'root',
})
// NGC-14350 - Move link operations from abstract-base-component due to issues with environment tokens replacement
export class LinkService {
  constructor(private envConfigService: EnvConfigService) {}

  /**
   * Parse widen document json and read url
   * @param widenDocument - Widen document Json
   */

  private getWidenDocumentUrl(widenDocument: any): string {
    let url;
    if (widenDocument) {
      const widenJson = JSON.parse(widenDocument);
      url = widenJson.url;
    }
    return url;
  }

  /**
   * Return absolute link
   * @param linkCompound - Link object
   * @param cmsURL - CMS URL string
   */
  private getCmsUrl(linkCompound: Link, cmsURL: string): string {
    if (linkCompound.url.startsWith('/')) {
      return `${cmsURL}${linkCompound.url}`;
    }
    return `${cmsURL}/${linkCompound.url}`;
  }

  /**
   * Replace environment token if it is in link
   * @param linkURL - URL string
   */
  private replaceEnvToken(linkURL: string): string {
    if (/\$ENV/.test(linkURL)) {
      return replaceTokens(linkURL, this.envConfigService.getEnvConfig());
    }
    return linkURL;
  }

  /**
   * Read the link compound and return the url
   * @param page - Page
   * @param linkCompound - Link object
   * @param cmsURL - CMS URL string
   */
  public getCTALink(page: Page, linkCompound: Link, cmsURL?: string): string {
    if (linkCompound) {
      // Return document asset
      if (linkCompound.document) {
        return page.getContent(linkCompound.document)?.getUrl();
      }
      // Return Widen asset
      if (linkCompound.widenAssetCompound) {
        return this.getWidenDocumentUrl(
          linkCompound.widenAssetCompound?.widenDocument
        );
      }

      if (linkCompound.url) {
        // Checking if URL starts with "absolute" path or with $ENV variable.
        const regex = /^http:|^https:|^mailto:|\$ENV/;
        // Return URL defined in resourceapi
        if (regex.test(linkCompound.url)) {
          return this.replaceEnvToken(linkCompound.url);
        }
        // Adding cmsUrl to link if required
        if (cmsURL) {
          return this.getCmsUrl(linkCompound, cmsURL);
        }
      }
    }
  }
}
